import { Controller } from "@hotwired/stimulus"

// "Keep near Jane" on a contact's ... menu: puts the person beside the
// floating Jane avatar (or takes them away). The avatar listens for
// jane:people-changed and redraws its stack.
export default class extends Controller {
  static targets = ["label", "icon"]
  static values = { url: String, kept: Boolean }

  connect() {
    this._onPeopleChanged = (event) => {
      if (event.detail?.url === this.urlValue) this.keptValue = event.detail.kept
    }
    window.addEventListener("jane:people-changed", this._onPeopleChanged)
  }

  disconnect() {
    window.removeEventListener("jane:people-changed", this._onPeopleChanged)
  }

  keptValueChanged() {
    if (this.hasLabelTarget) this.labelTarget.textContent = this.keptValue ? "Remove from beside Jane" : "Keep near Jane"
    if (this.hasIconTarget) this.iconTarget.className = `bi ${this.keptValue ? "bi-person-dash" : "bi-person-plus"}`
  }

  async toggle() {
    const token = document.querySelector("meta[name='csrf-token']")?.content
    const keep = !this.keptValue
    try {
      const response = await fetch(this.urlValue, {
        method: "PATCH",
        headers: { "Content-Type": "application/json", Accept: "application/json", "X-CSRF-Token": token || "" },
        credentials: "same-origin",
        body: JSON.stringify({ keep })
      })
      const data = await response.json()
      if (data.full) {
        window.alert("Jane keeps up to five people beside her. Remove someone first.")
        return
      }
      this.keptValue = Boolean(data.kept)
      window.dispatchEvent(new CustomEvent("jane:people-changed", { detail: { url: this.urlValue, kept: this.keptValue } }))
    } catch (_error) {
      // Nothing changed; the menu still says so.
    }
  }
}
